import { createContext } from 'utils/react-helpers';

const [CompanyProvider, useCompany] = createContext({ name: 'CompanyContext' });

export { CompanyProvider, useCompany };
